module.exports = __webpack_public_path__ + "img/@temp_gate03_1200_800.f578cc24.jpg";